export const ACCOUNTING_ACCOUNT_LOADINGS = {
  GET_LIST: "loadingList",
  GET_SAT_CODES: "loadingCodes",
  CREATE: "loadingCreation",
  UPDATE: "loadingUpdate",
  DELETE: "loadingDeletion",
};

const ACCOUNTING_ACCOUNT_TYPES = {
  CREATE_ACCOUNTING_ACCOUNT: "ACCOUNTING_ACCOUNT/CREATE",
  DELETE_ACCOUNTING_ACCOUNT: "ACCOUNTING_ACCOUNT/DELETE",
  UPDATE_ACCOUNTING_ACCOUNT: "ACCOUNTING_ACCOUNT/UPDATE",
  GET_ACCOUNTING_ACCOUNT_LIST: "ACCOUNTING_ACCOUNT/GET_LIST",
  GET_SAT_GROUPING_CODES: "ACCOUNTING_ACCOUNT/GET_SAT_CODES",
  RESTORE_INITIAL_STATE: "ACCOUNTING_ACCOUNT/RESTORE_INITIAL_STATE",
  SET_ACCOUNTING_ACCOUNT_SEARCH_FILTERS: "ACCOUNTING_ACCOUNT/SET_SEARCH_FILTERS",
};

export default ACCOUNTING_ACCOUNT_TYPES;
